import React, { useEffect, useState, useRef, useCallback } from "react";
import { Route, HashRouter as Router, Link, Switch, RouteComponentProps } from "react-router-dom";

import styles from "./mobilecenter.module.css";

import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

import MobileOpinionWrite from '../opinion/mobileopinionwrite';

import MobileEdit from "../edit/mobileedit";
import MobileEditWrite from "../edit/mobileeditwrite";

import MobileDashboard from "../dashboard/mobiledashboard";
import MobileOpinionMain from '../opinion/mobileopinionmain';
import MobileMyOpinionDetail from '../opinion/mobilemyopiniondetail';
import MobileChat from '../chat/mobilechat';

import mobileSocketControl from "../socket/mobilesocketcontrol";
import { IonApp } from "@ionic/react";
import { Socket } from "socket.io-client";
import MobileChatRoom from "../chat/mobilechatroom";

import nativePushRegistartion from "../../service/pushnotification";
import app from "../../service/firebaseinit";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { useHistory, useLocation } from "react-router-dom";
import { useIonAlert } from "@ionic/react";
import MobileRestaurant from "../restaurant/mobilerestaurant";
import { RegularMealDeadlines } from "../../etc/regularmealdeadline";
import MobileSuccess from "../success/mobilesuccess";
import MobileRechargetText from "../restaurant/mobilerechargetext";
import MobileProfilePicture from "../profile/mobileprofilepicture";
import MobileTotal from "../total/mobiletotal";
import StudyTimeRanking from "../dashboard/studytimeranking";
import MobileOnlineQuestion from "../onlinequestion/mobileonlinequestion";
import MobileOnlineQuestionWrite from "../onlinequestion/mobileonlinequestionwrite";
import MobileOfflineQuestion from "../offlinequestion/mobileofflinequestion";
import MobileOfflineQuestionWrite from "../offlinequestion/mobileofflinequestionwrite";
import NotificationList from "../notification/notificationlist";
import NotificationDetail from "../../dashboard/components/controls/notificationdetail";
import AttendanceMobileReal from "../attendance/mobileattendance";
import MobileNotificationDetailForDashboard from "../dashboard/mobilenotificationdetailfordashboard";
import MobileConsultReport from "../consultreport/mobileconsultreport";
import MobileRegular from "../regular/mobileregular";

import { useMediaQuery } from "react-responsive";

import { CapacitorUpdater } from "@capgo/capacitor-updater";

import { checkMobileMainUpdate } from "../../etc/functions";
import MobileTotalMenu from "../totalmenu/mobiletotalmenu";

import { App, AppState, BackButtonListenerEvent } from "@capacitor/app";
import MobileTimeTable from "../timetable/mobiletimetable";
import MobileWordtest from "../wordtest/mobilewordtest";
import MobileChatRoomForFamily from "../chat/mobilechatroomforfamily";
import MobileUpdate from "../update/mobileupdate";
import UpdateModal from "../components/updatemodal";
import MobileWifiPermit from "../wifipermit/mobilewifipermit";
import MobileCheck from "../check/mobilecheck";
import MobileCheckWrite from "../check/mobilecheckwrite";
import MobileBroadcast from "../broadcast/mobilebroadcast";
import { getFetch } from "../../fetch/fetch";
import MobileMealTicketText from "../restaurant/mobilemealtickettext";
import MobileContents from "../contents/mobilecontents";
import MobileContentsDetail from "../contents/mobilecontentsdetail";
import ReservationClean from "../reservationclean/reservationclean";
import CleanReport from "../reservationclean/cleanreport";
import MobileChatRoomForMentor from "../chat/mobilechatroomformentor";
import MobileChatRoomForFeedback from "../chat/mobilechatroomforfeedback";
import MobileChatForMentor from "../chat/mobilechatformentor";
import MobileMyCoaching from "../mycoaching/mobilemycoaching";
import FillOutEmbed from "../mycoaching/forms/fillout";
import MobileCoachDetail from "../mycoaching/mobilecoachdetail";
import MobileCoachSelectFinish from "../mycoaching/mobilecoachselectfinish";

import { SafeArea } from "@capacitor-community/safe-area";
import MobileContentsBuy from "../buycontents/mobilecontentsbuy";
import MobileContentsDetailForBuy from "../buycontents/mobilecontentsdetail";
import MobileContentText from "../buycontents/mobilecontenttext";

SafeArea.enable({
    config : {
        customColorsForSystemBars : true,
        statusBarColor : "#000000",
        statusBarContent : "dark",
        navigationBarColor : "#000000",
        navigationBarContent : "light",
    }
})




interface centerProps extends RouteComponentProps {
    socket: Socket;
    currentScreen: string;
}

interface user {
    name: string;
    value: "student" | "teacher" | "parent" | "staff";
    id: number;
    studentName: string | undefined | null;
    studentId: number | undefined | null;
    academy?: string;
    location?: string;
}

const MobileCenter: React.FC<any> = (centerProps) => {
    const [user, setUser] = useState<user | null>(null);
    const [count, setCount] = useState(0);
    const [messageUpdate, setMessageUpdate] = useState(0);
    const [familyMessageUpdate, setFamilyMessageUpdate] = useState({ number: 0, isUpdateNeeded: true });
    const [mentorMessageUpdate, setMentorMessageUpdate] = useState({ number : 0, isUpdateNeeded: true });
    const [feedbackMessageUpdate, setFeedbackMessageUpdate] = useState({ number: 0, isUpdateNeeded: true });
    const [chargeUpdate, setChargeUpdate] = useState(0);
    const history = useHistory();
    const location = useLocation();
    const [presentAlert] = useIonAlert();

    const [open, setOpen] = useState(false);

    const isLandscape = useMediaQuery({
        orientation: "landscape"
    });
    const [isOnlyCenter, setIsOnlyCenter] = useState(false);
    const [updateUrl, setUpdateUrl] = useState("");
    //지점별 정기식 설정 (서버 주도 - 로그인 직후 로드해서 도시락 신청 화면 진입 시 깜빡임 방지)
    const [regularMealSetting, setRegularMealSetting] = useState<{ price: number, isMenuVisible: boolean, deadlines: RegularMealDeadlines | null }>({ price: 8000, isMenuVisible: false, deadlines: null });

    const requestTimestampsRef = useRef<number[]>([]);
    const lastCallTimeRef = useRef<number>(0);

    //소켓 이벤트 폭주 시 setMessageUpdate를 2초에 최대 1회로 병합하기 위한 ref
    const messageUpdateTimerRef = useRef<any>(null);
    const lastMessageUpdateTimeRef = useRef<number>(0);
    const [mentorCount, setMentorCount] = useState(0);


    const backButtonHandler = (e: BackButtonListenerEvent) => {

        //history.goBack()
    }


    //안드로이드 일때 백버튼 작용하기
    useEffect(() => {

        if (Capacitor.getPlatform() === "android") {
            App.addListener("backButton", backButtonHandler);

            return () => {
                App.removeAllListeners();
            }
        }

    }, []);


    const handleStateChange = (state: AppState) => {


        if (state.isActive) {
            setTimeout(() => {
                unreadMessage();
            }, 3000);
        }
    }


    //스마트폰 백그라운드에서 포어그라운드로 올 때 한번 더 공지사항 새로운거 채팅 새로운거 확인해주기
    useEffect(() => {


        App.addListener("appStateChange", handleStateChange);


        return () => {
            App.removeAllListeners();
        }

    }, []);


    useEffect(() => {
        if (Capacitor.isNativePlatform()) {

            checkMobileMainUpdate(presentAlert, handleOpen, setUrl);
        }
    }, []);

    useEffect(() => {

        if (isLandscape && Capacitor.isNativePlatform()) {
            setIsOnlyCenter(true);
        } else {
            setIsOnlyCenter(false);
        }

    }, [isLandscape]);

    useEffect(() => {

        //notifyAppReady()는 src/index.tsx(부팅 엔트리)로 이동함. 여기서는 list()만.
        if (Capacitor.isNativePlatform()) {
            CapacitorUpdater.list();
        }

    }, []);


    //처음 dashboard 진입 시 토큰 가지고 있는지랑 가지고 있다면 토큰 정보 받기-------
    useEffect(() => {
        start();
    }, []);
    //-----------------------------------------------------------------------


    const start = async () => {
        var token: any = "";
        //-----// 만약 electron 이라면 저장되어 있는 토큰 가져오는 기능----------
        if (window.electron) {
            token = await window.electron.sendMessageApi.getToken();
        }
        //------------------------------------------------------------------

        //네이티브 라면 토큰 가져오는 기능
        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });

            token = value;
        }



        fetch("https://peetsunbae.com/dashboard/home/start", {
            method: "GET",
            credentials: "include",
            headers: { 'Authorization': token }
        }).then((response) => {
            response.json()
                .then((result) => {

                    if (result.message === "LOGIN") {
                        setUser({
                            name: result.name,
                            value: result.value,
                            id: result.id,
                            studentName: result.studentName,
                            studentId: result.studentId,
                            academy: result.academy,
                            location: result.location
                        });

                        //지점별 정기식 설정 로드 (탭 이름·정기식 탭 노출·식권 가격 전부 서버 주도)
                        getFetch("/dashboard/restaurant/regularmeal/mysetting").then((settingResult: any) => {
                            if (settingResult.message === "success") {
                                setRegularMealSetting({ price: settingResult.price, isMenuVisible: settingResult.isMenuVisible, deadlines: settingResult.deadlines ? settingResult.deadlines : null });
                            }
                        }).catch(() => { });

                    }
                    if (result.message === "NOT_LOGIN") {
                        //청소 보고 공유 링크(cleanreport)는 비로그인도 현장 비밀번호로 열람 가능하므로 로그인 화면으로 보내지 않음
                        if (window.location.hash.includes("/mobiledashboard/cleanreport")) {
                            return;
                        }
                        centerProps.history.push("/");
                    }
                })
        }).catch(error => {

        })
    }

    //push 등록----------------------------------------------------------------------------

    useEffect(() => {
        //web인 상태에서 푸시 메세지
        if (!Capacitor.isNativePlatform()) {


            const messaging = getMessaging(app);

            getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY }).then(async (currentToken) => {
                if (currentToken) {



                    const { value } = await Preferences.get({ key: "token" });

                    const userIdToken = "";


                    fetch("https://peetsunbae.com/push/registration", {
                        method: "post",
                        headers: {
                            "content-type": "application/json",
                            "Authorization": userIdToken
                        },
                        credentials: "include",
                        body: JSON.stringify({
                            token: currentToken
                        })
                    }).then((response: any) => {
                        response.json()
                            .then((result: any) => {

                            })
                    })

                    onMessage(messaging, (payload) => {


                    })

                } else {

                }
            }).catch((err) => {

            })

        }
    }, [])

    useEffect(() => {
        nativePushRegistartion(history, presentAlert);
    }, [])

    //-------------------------------------------------------------------------------

    //소켓이 자기 방 알려주는 곳-----------------------------------------------------------------
    useEffect(() => {
        if (user && centerProps.socket) {
            centerProps.socket.emit("myRoom", user.id);

            if (user.value === "teacher" || user.value === "staff") {

                centerProps.socket.emit("teacherRoom");
            }

        }

    }, [user, centerProps.socket]);

    //서버 껏다 켰을때 소켓이 방 다시 알려주는 기능-----------------------------
    useEffect(() => {
        if (!user) {
            return;
        }

        const sendMyRoom = () => {
            if (user) {
                centerProps.socket.emit("myRoom", user.id);

                if (user.value === "teacher" || user.value === "staff") {

                    centerProps.socket.emit("teacherRoom");
                }
            }
        }

        centerProps.socket.on("connect", sendMyRoom);

        //cleanup 없이 user 변경마다 리스너가 누적되어 재연결 1회에 join emit이 여러 번 나가던 누수 수정
        //(핸들러를 지정해서 off 해야 다른 곳의 connect 리스너를 건드리지 않음)
        return function cleanup() {
            centerProps.socket.off("connect", sendMyRoom);
        }

    }, [user]);

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------------------------------


    //chat 관련 함수들-----------------------------------------------------------------------------------------

    //답장 안한 message 갯수 물어보는 기능
    const unreadMessage2 = async () => {
        var token: any = "";
        //-----// 만약 electron 이라면 저장되어 있는 토큰 가져오는 기능----------
        if (window.electron) {
            token = await window.electron.sendMessageApi.getToken();
        }
        //------------------------------------------------------------------

        //네이티브 라면 토큰 가져오는 기능
        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });

            token = value;
        }

        fetch("https://peetsunbae.com/dashboard/envelope/number", {
            method: "GET",
            credentials: "include",
            headers: { 'Authorization': token }
        }).then((response) => {
            response.json()
                .then((result) => {

                    const userKind = result.userKind;

                    var newCount = result.data;
                    const familyUnreadNumber = result.familyUnreadNumber;
                    if (familyUnreadNumber) {
                        newCount += familyUnreadNumber;
                    }

                    const feedbackUnreadNumber = result.feedbackUnreadNumber;
                    if (feedbackUnreadNumber) {
                        newCount += feedbackUnreadNumber;
                    }

                    const mentorCount = result.mentorCount;

                    if (mentorCount !== undefined && mentorCount !== null) {

                        if (userKind === "teacher") {
                            setMentorCount(mentorCount);
                        } else {
                            newCount += mentorCount;
                        }

                    }

                    setCount(newCount);
                })
        }).catch(error => {

        })
    }

    const unreadMessage = useCallback(() => {

        const now = Date.now();

        requestTimestampsRef.current = requestTimestampsRef.current.filter((timestamp) => now - timestamp < 3000);

        requestTimestampsRef.current.push(now);

        if (requestTimestampsRef.current.length < 5) {
            unreadMessage2();
            lastCallTimeRef.current = now;
        } else {
            if (now - lastCallTimeRef.current > 2000) {
                unreadMessage2();
                lastCallTimeRef.current = now;
            }
        }

    }, [unreadMessage2]);

    //setMessageUpdate(Math.random())는 하위 컴포넌트들의 목록 재조회(getChatRooms 등)를 일제히 발화시키므로
    //소켓 이벤트 폭주(단체발송 후 읽음 이벤트 등) 시 2초에 최대 1회로 병합한다.
    //한동안 이벤트가 없었으면 즉시 반영(leading)해서 평상시 실시간성은 유지.
    const scheduleMessageUpdate = useCallback(() => {

        const now = Date.now();

        if (now - lastMessageUpdateTimeRef.current > 2000) {
            lastMessageUpdateTimeRef.current = now;
            setMessageUpdate(Math.random());
            return;
        }

        if (messageUpdateTimerRef.current) {
            return;
        }

        messageUpdateTimerRef.current = setTimeout(() => {
            messageUpdateTimerRef.current = null;
            lastMessageUpdateTimeRef.current = Date.now();
            setMessageUpdate(Math.random());
        }, 2000);

    }, []);

    useEffect(() => {

        unreadMessage();

    }, [location.pathname]);


    useEffect(() => {

        if (!centerProps.socket) {
            return;
        }

        centerProps.socket.on("newChatMessage", () => {

            console.log("새로운 메세지 받음");


            // new window.Notification("새로운 메세지가 왔습니다.", {body : `메세지를 확인해주세요.`});

            unreadMessage();
            scheduleMessageUpdate();
        })

        return function cleanup() { centerProps.socket.off("newChatMessage"); }

    }, [centerProps.socket]);

    useEffect(() => {

        if (!user) {
            return;
        }

        if (!centerProps.socket) {
            return;
        }

        if (user.value === "teacher" || user.value === "staff") {

            centerProps.socket.on("studentReadMessage", (chatRoomId : any, academy : any) => {

                console.log("학생이 메세지 읽음");


                // new window.Notification("새로운 메세지가 왔습니다.", {body : `메세지를 확인해주세요.`});

                //신버전 서버는 (chatRoomId, academy)를 실어줌 → 다른 학원 이벤트는 무시
                //구버전 서버는 인자가 없으므로 기존 동작 그대로
                //(모바일은 로그인 시 sunbaesha→sunbae 정규화를 안 하므로 양쪽 다 정규화해서 비교)
                if (academy && user.academy) {
                    const eventAcademy = academy === "sunbaesha" ? "sunbae" : academy;
                    const myAcademy = user.academy === "sunbaesha" ? "sunbae" : user.academy;
                    if (eventAcademy !== myAcademy) {
                        return;
                    }
                }

                unreadMessage();
                scheduleMessageUpdate();
            })

            return function cleanup() { centerProps.socket.off("studentReadMessage"); }

        }

    }, [user, centerProps.socket]);

    //---------------------------------------------------------------------------------------------------------

    useEffect(() => {

        if (!centerProps.socket) {
            return;
        }

        centerProps.socket.on("newFamilyMessage", () => {

            console.log("새로운 가족 메세지 받음");

            unreadMessage();
            scheduleMessageUpdate();

            const newFamilyMessageUpdate = {
                number: Math.random(),
                isUpdateNeeded: true
            }

            setFamilyMessageUpdate({ ...newFamilyMessageUpdate });

        })

        centerProps.socket.on("familyReadMessage", () => {

            console.log("가족 메세지 읽음");


            unreadMessage();
            scheduleMessageUpdate();

            const newFamilyMessageUpdate = {
                number: Math.random(),
                isUpdateNeeded: false
            }

            setFamilyMessageUpdate({ ...newFamilyMessageUpdate });

        })

        return function cleanup() { centerProps.socket.off("familyReadMessage"); centerProps.socket.off("newFamilyMessage"); }

    }, [centerProps.socket]);

    useEffect(() => {

        if (!centerProps.socket) {
            return;
        }

        centerProps.socket.on("newCoachMessage", () => {

            console.log("새로운 멘토 메세지 받음");

            unreadMessage();
            scheduleMessageUpdate();

            const newMentorMessageUpdate = {
                number: Math.random(),
                isUpdateNeeded: true
            }

            setMentorMessageUpdate({ ...newMentorMessageUpdate });

        })

        centerProps.socket.on("coachReadMessage", () => {

            console.log("멘토 메세지 읽음");

            unreadMessage();
            scheduleMessageUpdate();

            const newCoachMessageUpdate = {
                number: Math.random(),
                isUpdateNeeded: false
            }

            setMentorMessageUpdate({ ...newCoachMessageUpdate });

        })

        return function cleanup() { centerProps.socket.off("newCoachMessage"); centerProps.socket.off("coachReadMessage"); }

    }, [centerProps.socket]);

    useEffect(() => {

        if (!centerProps.socket) {
            return;
        }

        centerProps.socket.on("newFeedbackMessage", () => {
            unreadMessage();
            setFeedbackMessageUpdate({ number: Math.random(), isUpdateNeeded: true });
        });

        centerProps.socket.on("feedbackReadMessage", () => {
            unreadMessage();
            //주의: 읽음 이벤트이므로 isUpdateNeeded는 false여야 함.
            //true로 두면 향후 피드백방에 다른 방들처럼 읽음 emit 가드를 붙일 때 read→emit→read 무한 루프가 됨
            setFeedbackMessageUpdate({ number: Math.random(), isUpdateNeeded: false });
        });

        return function cleanup() {
            centerProps.socket.off("newFeedbackMessage");
            centerProps.socket.off("feedbackReadMessage");
        }

    }, [centerProps.socket]);

    const handleOpen = (boolean: boolean) => {
        setOpen(boolean);
    }

    const setUrl = (url: string) => {
        setUpdateUrl(url);
    }

    return (
        <Router>
            <Switch>
                <Route exact path="/mobiledashboard" render={(props) => <MobileDashboard user={user} socket={centerProps.socket} unreadMessage={count} unread={unreadMessage} mentorCount={mentorCount} {...props} />}></Route>
                <Route exact path="/mobiledashboard/opinion" render={(props) => <MobileOpinionMain {...props}></MobileOpinionMain>}></Route>
                <Route exact path="/mobiledashboard/opinion/write" render={(props) => <MobileOpinionWrite user={user} />} ></Route>
                <Route exact path="/mobiledashboard/opinion/detail" component={MobileMyOpinionDetail}></Route>
                <Route exact path="/mobiledashboard/edit" render={(props) => <MobileEdit unreadMessage={count} unread={unreadMessage} mentorCount={mentorCount} />}  ></Route>
                {/* <Route exact path="/mobiledashboard/edit/write" component={MobileEditWrite}></Route> */}
                <Route exact path="/mobiledashboard/envelope" render={(props) => <MobileChat user={user} unreadMessage={count} unread={unreadMessage} mentorCount={mentorCount} messageUpdate={messageUpdate} familyMessageUpdate={familyMessageUpdate} socket={centerProps.socket} {...props} />}></Route>
                <Route exact path="/mobiledashboard/envelope/room" render={(props) => <MobileChatRoom user={user} socket={centerProps.socket} unreadMessage={unreadMessage} messageUpdate={messageUpdate} {...props} />}></Route>
                <Route exact path="/mobiledashboard/envelope/familyroom" render={(props) => <MobileChatRoomForFamily user={user} socket={centerProps.socket} unreadMessage={unreadMessage} messageUpdate={messageUpdate} familyMessageUpdate={familyMessageUpdate} {...props} />}></Route>
                <Route exact path="/mobiledashboard/envelope/feedbackroom" render={(props) => <MobileChatRoomForFeedback user={user} socket={centerProps.socket} unreadMessage={unreadMessage} messageUpdate={messageUpdate} feedbackMessageUpdate={feedbackMessageUpdate} {...props} />}></Route>
                <Route exact path="/mobiledashboard/restaurant" render={(props) => <MobileRestaurant user={user} socket={centerProps.socket} regularMealSetting={regularMealSetting} />} />
                <Route exact path="/mobiledashboard/rechargetext" render={(props) => <MobileRechargetText user={user} />} />
                <Route exact path="/mobiledashboard/mealtickettext" render={(props) => <MobileMealTicketText user={user} />} />
                <Route exact path="/mobiledashboard/success" render={(props) => <MobileSuccess user={user} />} />
                <Route exact path="/mobiledashboard/profilepicture" render={(props) => <MobileProfilePicture user={user} />} />
                <Route exact path="/mobiledashboard/total" render={(props) => <MobileTotal user={user} unreadMessage={count} mentorCount={mentorCount} />} />
                <Route exact path="/mobiledashboard/studytimeranking" render={(props) => <StudyTimeRanking user={user} />} />
                <Route exact path="/mobiledashboard/onlinequestion" render={(props) => <MobileOnlineQuestion user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/onlinequestionwrite" render={(props) => <MobileOnlineQuestionWrite user={user} />} />
                <Route exact path="/mobiledashboard/offlinequestion" render={(props) => <MobileOfflineQuestion user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/offlinequestionwrite" render={(props) => <MobileOfflineQuestionWrite user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/checkwrite" render={(props) => <MobileCheckWrite user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/notificationlist" render={(props) => <NotificationList user={user} socket={centerProps.socket} unreadMessage={count} unread={unreadMessage} mentorCount={mentorCount} />} />
                <Route exact path="/mobiledashboard/notificationdetail" render={(props) => <NotificationDetail user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/attendance" render={(props) => <AttendanceMobileReal user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/mobilenotificationdetailfordashboard" render={(props) => <MobileNotificationDetailForDashboard user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/consultreport" render={(props) => <MobileConsultReport user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/regular" render={(props) => <MobileRegular user={user} />} />
                <Route exact path="/mobiledashboard/totalmenu" render={(props) => <MobileTotalMenu user={user} unreadMessage={count} unread={unreadMessage} mentorCount={mentorCount} />} />
                <Route exact path="/mobiledashboard/timetable" render={(props) => <MobileTimeTable user={user} />} />
                <Route exact path="/mobiledashboard/wordtest" render={(props) => <MobileWordtest user={user} />} />
                <Route exact path="/mobiledashboard/update" render={(props) => <MobileUpdate user={user} />} />
                <Route exact path="/mobiledashboard/wifipermit" render={(props) => <MobileWifiPermit user={user} />} />
                <Route exact path="/mobiledashboard/checklist" render={(props) => <MobileCheck user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/broadcast" render={(props) => <MobileBroadcast user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/contents" render={(props) => <MobileContents user={user} />} />
                <Route exact path="/mobiledashboard/buycontents" render={(props) => <MobileContentsBuy user={user} />} />
                <Route exact path="/mobiledashboard/contentdetail" render={(props) => <MobileContentsDetail user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/reserveclean" render={(props) => <ReservationClean user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/cleanreport" render={(props) => <CleanReport user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/envelope/mentorroom" render={(props) => <MobileChatRoomForMentor user={user} socket={centerProps.socket} unreadMessage={unreadMessage} messageUpdate={messageUpdate} mentorMessageUpdate={mentorMessageUpdate} />} />
                <Route exact path="/mobiledashboard/envelopeformentor" render={(props) => <MobileChatForMentor user={user} socket={centerProps.socket} unreadMessage={count} mentorCount={mentorCount} messageUpdate={messageUpdate} mentorMessageUpdate={mentorMessageUpdate} />} />
                <Route exact path="/mobiledashboard/mycoaching" render={(props) => <MobileMyCoaching user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/filloutembed" render={(props) => <FillOutEmbed />} />
                <Route exact path="/mobiledashboard/teacherdetail" render={(props) => <MobileCoachDetail user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/mycoaching/coachselectfinish" render={(props) => <MobileCoachSelectFinish user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/contentdetailforbuy" render={(props) => <MobileContentsDetailForBuy user={user} socket={centerProps.socket} />} />
                <Route exact path="/mobiledashboard/contenttext" render={(props) => <MobileContentText user={user} socket={centerProps.socket} />} />

            </Switch>
            <UpdateModal open={open} updateUrl={updateUrl} onClose={() => { }} />
        </Router>
    );
}

export default MobileCenter;